// @ts-expect-error bender imports are untyped
import defaultAvatar from 'bender-url!../../../img/default-avatar.png';
import { AccountsMenu } from './AccountsMenu';
import { formatName } from '../../../js/utils/formatName';
import useAccountsData from '../../hooks/useAccountsData';
import ErrorBoundary from '../ErrorBoundary';
import { MenuButton } from '../Menu';
import OnboardingProgressListener from './OnboardingProgress/OnboardingProgressListener';
import { ACCOUNT_MENU_WIDTH } from './constants';
import { forwardRef } from 'react';
import { isGlobalNavAcademyMode } from '../../utils/navEnviro';
import NewArrowDown from '../icons/ArrowDown';
import useBusinessUnits from '../../hooks/useBusinessUnits';
import useMedia from '../../hooks/useMedia';
import { useIsUngated } from '../../hooks/useIsUngated';
import { RESPONSIVE_TOOLBAR } from '../../constants/gates';
import { BREAKPOINT_LARGE } from 'nav-meta/constants';
import { useTranslation } from '../../hooks/useNavConfig';
import styled, { css, useTheme } from 'foundations-theming-specialty/utils';
import { getAccountMenuBorder } from './shared-styles';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const popoverContainerStyles = css(({
  theme
}) => ({
  display: 'block',
  background: theme.color['fill-surface-default'],
  border: `${getAccountMenuBorder(theme)} !important`,
  borderRadius: theme.borderRadius['100'],
  padding: `${theme.space['0']} !important`,
  margin: `${theme.space['0']} !important`,
  width: `${ACCOUNT_MENU_WIDTH}px`
}));
const StyledMenuButton = styled(MenuButton)(({
  theme
}) => {
  return css(["position:relative;background:none;border:0;font-weight:500;cursor:pointer;padding:0 12px;margin:0;display:flex;align-items:center;height:100%;font-size:13px;white-space:nowrap;border-radius:6px;&:hover{background:", ";svg{fill:", " !important;}span{color:", " !important;}}img{border-radius:50%;height:16px;width:16px;}span{color:", " !important;display:none;font-size:14px !important;font-weight:400 !important;margin:0 6px 0 8px !important;height:18px;line-height:18px !important;@media screen and (min-width:924px){display:inline-block;}}svg{margin-left:4px !important;@media screen and (min-width:924px){margin-left:0;}}"], theme.color['global-shell-fill-nav-item-hover'], theme.color['global-shell-icon-nav-item-hover'], theme.color['global-shell-text-nav-item-hover'], theme.color['global-shell-text-nav-item-default']);
});
export const Accounts = /*#__PURE__*/forwardRef(({
  avatarUrl = '',
  accountName = '',
  firstName,
  lastName,
  displayName,
  userEmail,
  scopes,
  isDevPortal,
  hasProjectAccess,
  isEnrolledInOnboarding,
  popoverPadding,
  id,
  tabIndex,
  onKeyDown
}, ref) => {
  const accounts = useAccountsData();
  const {
    t
  } = useTranslation();
  const theme = useTheme();
  const {
    businessUnits,
    currentBusinessUnit,
    businessUnitDisplayText
  } = useBusinessUnits();
  const responsiveToolbarEnabled = useIsUngated(RESPONSIVE_TOOLBAR);
  const isGridBreakpointLarge = useMedia(`screen and (max-width: ${BREAKPOINT_LARGE})`);
  const isAcademyMode = isGlobalNavAcademyMode();
  const avatarSrc = encodeURI(avatarUrl) || defaultAvatar;
  const userName = formatName({
    firstName,
    lastName
  }) || '…';
  const email = userEmail;
  const content = /*#__PURE__*/_jsx(AccountsMenu, {
    avatarUrl: avatarUrl,
    accountName: accountName,
    accounts: accounts,
    businessUnits: businessUnits,
    businessUnit: currentBusinessUnit,
    userName: userName,
    userEmail: email,
    scopes: scopes,
    isDevPortal: isDevPortal,
    hasProjectAccess: hasProjectAccess,
    isEnrolledInOnboarding: isEnrolledInOnboarding
  });
  const accountDisplayName = isGridBreakpointLarge && responsiveToolbarEnabled ? null : /*#__PURE__*/_jsx("span", {
    children: isAcademyMode ? displayName : `${accountName} ${businessUnitDisplayText}`
  });
  return /*#__PURE__*/_jsxs(ErrorBoundary, {
    boundaryName: "Global Toolbar - Account Menu",
    children: [/*#__PURE__*/_jsx(OnboardingProgressListener, {
      isEnrolledInOnboarding: isEnrolledInOnboarding
    }), /*#__PURE__*/_jsxs(StyledMenuButton, {
      id: id,
      "data-test-id": id,
      popoverContainerStyles: popoverContainerStyles,
      popoverContent: content,
      popoverPadding: popoverPadding,
      popoverPortalHookId: 'account-menu',
      popoverId: 'accounts-menu-content',
      "aria-label": t('nav.other.account.menu.label'),
      ref: ref,
      tabIndex: tabIndex,
      onKeyDown: onKeyDown,
      dismissOnClickOutside: true,
      children: [/*#__PURE__*/_jsx("img", {
        src: avatarSrc,
        alt: userName
      }), accountDisplayName, /*#__PURE__*/_jsx(NewArrowDown, {
        fill: theme.color['global-shell-icon-nav-item-default']
      })]
    })]
  });
});